import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import filter from 'lodash/filter';
import { useTranslation } from 'react-i18next';
import map from 'lodash/map';
import get from 'lodash/get';
import { Row, Col, Spin, Empty, Avatar, Button, Input } from 'antd';
import styled from 'styled-components';
import useFetch from 'utils/fetch/useFetch';
import { useSelector } from 'react-redux';
import { USERS, BASE } from 'api';
import Search from './components/Seacrh';
import Modal from './components/ModalInfo';
import AddManager from './components/AddManager';
import { ReactComponent as Plus } from '../../images/plus.svg';

const Item = styled.div`
  &&& {
    height: 50px;
    background: white;
    box-shadow: 0px 1px 5px #f2f2f2;
    border-radius: 6px;
    margin-bottom: 5px;
    padding-left: 16px;
    padding-right: 16px;
    display: flex;
    align-items: center;
  }
`;

function Managers({}) {
  const [visible, setVisible] = useState(false);
  const { t } = useTranslation();
  const [visibleModal, setVisibleModal] = useState(false);
  const [user, setUser] = useState(null);
  const total = useSelector((state) =>
    get(state, `fetch.managers.total`, null),
  );
  const limit = useSelector((state) =>
    get(state, `fetch.managers.limit`, null),
  );
  const [stateSearch, setStateSearch] = useState(false);
  const [pushItems, setPushItems] = useState(null);
  const [generalTotal, setGeneralTotal] = useState(null);
  const { data, getData, loading, updateData, deleteData, loadMore } = useFetch(
    USERS,
    {
      uniqId: 'managers',
      autoFetch: false,
    },
  );

  const handleOpenModal = (data) => {
    setVisibleModal(!visibleModal);
    setUser(data);
  };

  useEffect(() => {
    getData({
      role: 'manager',
    });
  }, []);

  useEffect(() => {
    if (user) {
      const newData = filter(data, (item) => item.id === user.id);
      setUser(newData[0]);
    }
  }, [data]);

  const loadMoreItems = () => {
    if (stateSearch) {
      getData({
        search: stateSearch,
        limit: pushItems,
      });
      setPushItems(pushItems + 5);
    } else {
      loadMore(pushItems);
      setPushItems(pushItems + 5);
    }
  };

  useEffect(() => {
    if (total && !generalTotal) {
      setGeneralTotal(total);
    }
  }, [total]);

  useEffect(() => {
    if (data && !pushItems) setPushItems(data.length + 10);
  }, [data]);

  const User = (props) => {
    return (
      <Item>
        <Row className="w-full" type="flex">
          <Col className="flex items-center" span={5}>
            {props.data.avatar ? (
              <Avatar
                src={`${BASE}${props.data.avatar}`}
                className="w-42 flex items-center justify-center h-42"
              />
            ) : (
              <Avatar className="w-42 flex items-center justify-center h-42">
                {props.name[0]}
              </Avatar>
            )}
            <div
              onClick={() => {
                handleOpenModal(props.data);
              }}
              className="ml-10 cursor-pointer border-b-1 border-dotted"
            >
              {props.name}
            </div>
          </Col>
          <Col className="flex items-center" span={19}>
            <div className="w-26 mr-11 h-26 bg-primary rounded-full flex items-center justify-center text-white">
              {props.numberStorages}
            </div>
            <div className="flex items-center">
              {map(props.storages, (item) => {
                return `${item.warehouse.name} `;
              })}
            </div>
          </Col>
        </Row>
      </Item>
    );
  };

  return (
    <Spin spinning={loading}>
      <Search
        setStateSearch={setStateSearch}
        limit={limit}
        generalTotal={generalTotal}
        total={total}
        search={getData}
      />
      {data
        ? map(data, (item) => {
            return (
              <User
                key={item.id}
                data={item}
                name={`${item.first_name} ${item.last_name}`}
                numberStorages={item.warehouse_permissions.length}
                storages={item.warehouse_permissions}
              />
            );
          })
        : null}

      <div className="mt-20 pl-20 flex items-center">
        <Button
          onClick={() => {
            setVisible(!visible);
          }}
          className="flex mr-17 pl-1 justify-center p-0 items-center border-none bg-primary rounded-full w-18 h-18 hover:bg-primary focus:bg-primary"
        >
          <Plus className="p-0 m-0" />
        </Button>
        <div
          onClick={() => {
            setVisible(!visible);
          }}
          className="cursor-pointer text-graytext"
        >
          {t('addAdmin')}
        </div>
      </div>
      {user && (
        <Modal
          data={user}
          setUser={setUser}
          deleteData={deleteData}
          visible={visibleModal}
          updateData={updateData}
          setVisible={setVisibleModal}
          getUsers={getData}
        />
      )}
      {data ? (
        total !== data.length ? (
          <div className="flex w-full mt-20 mb-20 justify-center items-center">
            <Button
              type="primary"
              onClick={() => {
                loadMoreItems();
              }}
            >
              {t('loadMore')}
            </Button>
          </div>
        ) : null
      ) : null}
      <AddManager getData={getData} setVisible={setVisible} visible={visible} />
    </Spin>
  );
}

Managers.propTypes = {};

export default Managers;
